import { createApp } from 'vue'
import App from './App.vue'
import VueAxios from 'vue-axios'
//import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import router from './router'

// const router = createRouter({
//     history: createWebHistory(),
//     routes: [],
//   });
createApp(App)
    .use(router)
    .use(VueAxios, axios).mount('#app')
router.App = App;
